import React from 'react'
import { AppHeading } from 'components/Common/AppHeading/AppHeading.component'
import { AppLetUsKnowCard } from 'components/AppDataReport/AppTools/AppLetUsKnowCard.component'

export const AppHeader = () => {
  return (
    <div className="w-full flex justify-between items-center">
      <AppHeading>Let’s tackle your data!</AppHeading>
      <AppLetUsKnowCard />
    </div>
  )
}
